import settings from "../utils/settings";
import SFError from "../models/SfError";
const useCheckAuthorizeCode = () => {
  const checkAuth = async ({ offerId, pin }) => {
    const { token } = settings();
    try {
      const result = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/offers/${offerId}/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            authorize_pin: String(pin),
          }),
        }
      );

      const isOK = result.ok;
      const status = result.status;
      if (!isOK) {
        const jsonResult = await result.json();
        const error = new SFError({
          status: status,
          code: jsonResult.code,
          message: jsonResult.message,
        });

        return error.json();
      }
      const jsonResult = await result.json();
      return jsonResult;
    } catch (error) {
      const sfError = new SFError({ message: String(error) });
      return sfError.json();
    }
  };
  return { checkAuth };
};

export default useCheckAuthorizeCode;
